import { createRouter, createWebHistory } from "vue-router";

import AnstalldView from "@/views/anstalld/AnstalldView.vue";

import ArbetsgivareView from "@/views/arbetsgivare/ArbetsgivareView.vue";
import MinaArendenView from "@/views/minaarenden/MinaArendenView.vue";
import ReleaserView from "@/views/releaser/ReleaserView.vue";
import SearchView from "@/views/search/SearchView.vue";
import { registerGuard } from "./Guard";
import { puzzelReroute } from "./puzzelReroute";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: SearchView,
      beforeEnter: puzzelReroute,
    },
    {
      path: "/anstalld",
      name: "anstalld",
      component: AnstalldView,
    },
    {
      path: "/arbetsgivare",
      name: "arbetsgivare",
      component: ArbetsgivareView,
    },
    {
      path: "/releaser",
      name: "releaser",
      component: ReleaserView,
    },
    {
      path: "/releaser/:fullName",
      name: "release",
      component: ReleaserView,
      props: true,
    },
    {
      path: "/minaarenden",
      name: "minaarenden",
      component: MinaArendenView,
    },
  ],
});

registerGuard(router);

export default router;
